import axios from 'axios';
import router from "../router";
import store from "./index";

export const auth = {
  namespaced: true,
  state: {
    client: null,
    user: null,
    regions: [],
    permissions: {},
    key: null,
    login_method: null,
    is_logged_in: false,
    switched_user: false,
    switched_client: false,
    redirect: null,
    initialData: {}
  },
  mutations: {
    login (state, payload) {
      state.client = payload.client;
      state.user = payload.user;
      state.regions = Object.values(payload.regions).sort((a, b) => (a.name > b.name) ? 1 : -1);
      state.permissions = payload.permissions;
      state.key = payload.key;
      state.login_method = payload.login_method;
      state.is_logged_in = true;
      state.switched_user = false;
      state.switched_client = false;
    },
    switch(state, payload) {
      if (!(state.switched_user || state.switched_client)) {
        state.initialData = {
          client: state.client,
          user: state.user,
          regions: state.regions,
          permissions: state.permissions,
          key: state.key,
          login_method: state.login_method,
        };
      }
      state.client = payload.client;
      state.user = payload.user;
      state.regions = Object.values(payload.regions).sort((a, b) => (a.name > b.name) ? 1 : -1);
      state.permissions = payload.permissions;
      state.key = payload.key;
      state.login_method = payload.login_method;
      state.is_logged_in = true;
      state.switched_client = state.initialData.client.id !== state.client.id;
      state.switched_user = state.initialData.user.id !== state.user.id;
    },
    restore(state) {
      if (!(state.switched_user || state.switched_client)) return;
      Object.assign(state, state.initialData);
      state.initialData = {};
      state.switched_user = false;
      state.switched_client = false;
    },
    logout (state) {
      state.client = null;
      state.user = null;
      state.regions = [];
      state.permissions = {};
      state.key = null;
      state.login_method = null;
      state.is_logged_in = false;
      state.switched_user = false;
      state.switched_client = false;
      state.initialData = {};
    },
    setRedirect(state, path) {
      state.redirect = path;
    }
  },
  getters: {
    redirect_url: state => {
      return state.redirect || '/';
    },
    name: state => {
      if (state.user === null) return '';
      return state.user.full_name;
    },
    user_email: state => {
      if (state.user === null) return '';
      return state.user.email;
    },
    user_id: state => {
      if (state.user === null) return -1;
      return state.user.id;
    },
    user_avatar: state => {
      if (state.user === null) return '';
      return state.user.google_picture_link || 'https://s3-ap-southeast-2.amazonaws.com/bcrc.io/logo.png';
    },
    username: state => {
      if (state.user === null) return '';
      return state.user.username;
    },
    client_id: state => {
      if (state.client === null) return -1;
      return state.client.id;
    },
    client_name: state => {
      if (state.client === null) return '';
      return state.client.name;
    },
    client_logo: state => {
      if (state.client === null) return '';
      return state.client.logo || 'https://s3-ap-southeast-2.amazonaws.com/bcrc.io/logo.png';
    },
    isInternalUser: state => {
      if (state.client === null) return false;
      return state.client.id === 0;
    },
    isAdmin: (state, getters) => {
      return getters.hasPermission('admin');
    },
    hasAPIDocumentationPermission : (state, getters) => {
      return getters.hasPermission('api_documentation_view');
    },
    hasPermission: ( state ) => ( permission ) => {
      return (permission in state.permissions);
    },
    hasPermissionRegionId: ( state ) => ( permission, region ) => {
      if (!(permission in state.permissions)) return false;
      return state.permissions[permission].includes(region);
    },
    hasPermissionRegion: (state, getters) => (permission, region) => {
      return getters.hasPermissionRegionId(permission, region.id);
    },
    permissionRegions: ( state ) => (permission ) => {
      if (!(permission in state.permissions)) return [];
      return state.regions.filter((r) => {
        return state.permissions[permission].includes(r.id);
      });
    },
    regions: state => {
      return state.regions;
    },
  },
  actions: {
    async switch_user(context, id) {
      console.log('Switching to user ' + id);
      return axios.get(process.env.API_URL + '/users/' + id + '/auth')
        .then((response) => {
          if (response.status === 200) {
            context.commit('switch', response.data);
            axios.defaults.headers.common['X-API-KEY'] = context.state.key;
          } else {
            console.log(response.status)
          }
        })
        .catch((error) => {
          console.log(error);
        })
    },
    async switch_client(context, id) {
      console.log('Switching to Client ' + id);
      return axios.get(process.env.API_URL + '/clients/' + id + '/auth')
        .then((response) => {
          if (response.status === 200) {
            context.commit('switch', response.data);
            axios.defaults.headers.common['X-API-KEY'] = context.state.key;
          } else {
            console.log(response.status)
          }
        })
        .catch((error) => {
          console.log(error);
        })
    },
    restore_user(context) {
      context.commit('restore');
      axios.defaults.headers.common['X-API-KEY'] = context.state.key;
    },
    async password_login(context, payload) {
      return await axios.post(process.env.API_URL + '/users/login', {"username": payload.username, "password": payload.password})
        .then((response) => {
          if (response.status === 200) {
            context.commit('login', response.data);
            axios.defaults.headers.common['X-API-KEY'] = context.state.key;
            console.log(response.data);
            return true;
          } else {
            return false;
          }
        })
        .catch(function (error) {
          console.log(error);
          return false;
        });
    },
    async google_login(context, payload) {
      return await axios.post(process.env.API_URL + '/users/googlelogin?redirect_url=' + payload.redirect_url + '&code=' + payload.code)
        .then((response) => {
          if (response.status === 200) {
            context.commit('login', response.data);
            axios.defaults.headers.common['X-API-KEY'] = context.state.key;
            return true;
          } else {
            return false;
          }
        })
      .catch((error) => {
        console.log(error);
        return false;
      });
    },
    logout(context) {
      context.commit('logout');
      axios.defaults.headers.common['X-API-KEY'] = '';
      this.$cookie.delete('Api-Key', {domain: process.env.API_URL});
    },
    authloop(context) {
      context.dispatch('checkAuth');
      console.log('Starting authloop');
      setInterval(function() {
        context.dispatch('checkAuth');
      }, 10000)
    },
    async checkAuth(context) {
      if (!context.state.is_logged_in) return;
      return await axios.get(process.env.API_URL + '/regions')
        .then((response) => {
          if (response.status !== 200) {
            context.commit('logout');
            context.commit('setRedirect', router.router.currentRoute.fullPath);
            window.location.replace('/login');
          }
        })
        .catch((error) => {
          context.commit('logout');
          window.location.replace('/login');
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/store/auth.js